export interface ComicItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  tags: string[];
  cover: string;
  status: string;
  rating: number;
  chapters: number;
  author: string;
  update: string;
  description: string;
  intro: string;
  worldview: string[];
}

export interface Category {
  slug: string;
  name: string;
  en: string;
  desc: string;
  icon: string;
  cover: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: "fantasy",
    name: "奇幻妖精",
    en: "Fantasy",
    desc: "妖精与人类共存的神秘大陆，追寻血脉与宿命中的光。",
    icon: "ri-sparkling-2-fill",
    cover: "https://readdy.ai/api/search-image?query=mystical%20fairy%20forest%20with%20glowing%20mushrooms%20and%20floating%20light%20orbs%2C%20ethereal%20fantasy%20concept%20art%2C%20deep%20emerald%20and%20amber%20palette%2C%20detailed%20painterly%20style%2C%20magical%20atmosphere&width=720&height=520&seq=fantasy-cat&orientation=landscape",
    count: 186,
  },
  {
    slug: "magic",
    name: "魔法学院",
    en: "Magic",
    desc: "咒语、契约与禁忌之术，天赋觉醒的魔法师成长之路。",
    icon: "ri-magic-fill",
    cover: "https://readdy.ai/api/search-image?query=ancient%20wizard%20tower%20filled%20with%20floating%20spell%20books%20and%20glowing%20rune%20circles%2C%20fantasy%20magic%20academy%20concept%20art%2C%20warm%20golden%20light%20and%20teal%20glow%2C%20painterly%20style&width=720&height=520&seq=magic-cat&orientation=landscape",
    count: 154,
  },
  {
    slug: "isekai",
    name: "异世界",
    en: "Isekai",
    desc: "穿越、转生与契约召唤，在另一个世界重新书写人生。",
    icon: "ri-earth-fill",
    cover: "https://readdy.ai/api/search-image?query=portal%20gate%20opening%20to%20another%20world%20with%20floating%20islands%20and%20waterfall%2C%20isekai%20fantasy%20concept%20art%2C%20bright%20emerald%20and%20amber%20sky%2C%20cinematic%20composition&width=720&height=520&seq=isekai-cat&orientation=landscape",
    count: 201,
  },
  {
    slug: "elf",
    name: "精灵国度",
    en: "Elf",
    desc: "尖耳、森林与月之誓约，精灵一族的爱恨与荣光。",
    icon: "ri-leaf-fill",
    cover: "https://readdy.ai/api/search-image?query=elegant%20elf%20queen%20in%20luminous%20forest%20clearing%20with%20fireflies%2C%20high%20fantasy%20concept%20art%2C%20moonlight%20silver%20and%20deep%20green%2C%20refined%20painterly%20style&width=720&height=520&seq=elf-cat&orientation=landscape",
    count: 132,
  },
  {
    slug: "yokai",
    name: "妖怪志异",
    en: "Yokai",
    desc: "百鬼夜行、妖狐与山精，人与妖的古老纠葛传说。",
    icon: "ri-ghost-fill",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20yokai%20parade%20at%20night%20with%20fox%20spirit%20and%20paper%20lanterns%2C%20dark%20oriental%20fantasy%20concept%20art%2C%20ink%20wash%20and%20crimson%20accents%2C%20atmospheric&width=720&height=520&seq=yokai-cat&orientation=landscape",
    count: 118,
  },
  {
    slug: "myth",
    name: "神话新编",
    en: "Myth",
    desc: "古老神明苏醒，人类与神话重临的宏大史诗。",
    icon: "ri-goblet-fill",
    cover: "https://readdy.ai/api/search-image?query=colossal%20ancient%20gods%20and%20mythological%20beasts%20across%20the%20skies%2C%20epic%20mythology%20fantasy%20concept%20art%2C%20golden%20hour%20and%20deep%20teal%2C%20grand%20composition&width=720&height=520&seq=myth-cat&orientation=landscape",
    count: 97,
  },
];

export const comics: ComicItem[] = [
  {
    id: "moon-fairy-tale",
    title: "月影妖精谭",
    category: "奇幻妖精",
    categorySlug: "fantasy",
    tags: ["妖精", "宿命", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=ethereal%20fairy%20girl%20with%20translucent%20wings%20standing%20under%20the%20moon%20in%20a%20misty%20forest%2C%20fantasy%20manga%20cover%20art%2C%20silver%20moonlight%20and%20deep%20emerald%2C%20delicate%20painterly%20style&width=520&height=680&seq=moon-fairy&orientation=portrait",
    status: "连载中",
    rating: 4.8,
    chapters: 126,
    author: "白夜工房",
    update: "2小时前",
    description: "普通少女误入月下森林，与流亡的月之妖精王签订契约，卷入了一场跨越百年的宿命之战。",
    intro: "在这座被迷雾笼罩的森林里，住着一位只在满月时现身的妖精王。当少女澄澄在深夜捡到一枚银色的月石，她的命运便与这个消失千年的国度紧紧相连。",
    worldview: ["月之妖精国度与人类边界的设定", "契约之力与月华魔法的体系", "五位妖精长老的权力角逐"],
  },
  {
    id: "contract-mage",
    title: "禁忌魔法书",
    category: "魔法学院",
    categorySlug: "magic",
    tags: ["魔法", "学院", "热血"],
    cover: "https://readdy.ai/api/search-image?query=young%20mage%20holding%20a%20glowing%20forbidden%20spellbook%20surrounded%20by%20rune%20circles%2C%20magic%20academy%20manga%20cover%2C%20golden%20and%20teal%20glow%2C%20dynamic%20fantasy%20art&width=520&height=680&seq=forbidden-grimoire&orientation=portrait",
    status: "连载中",
    rating: 4.6,
    chapters: 98,
    author: "咒文社",
    update: "5小时前",
    description: "被贬为废材的天才少年捡到一本会说话的魔法书，从此开启横扫魔法学院的逆袭之路。",
    intro: "魔法学院最底层的杂役生烈焰，在一次清扫禁书区时，唤醒了一本沉睡三百年的禁忌魔法书。书中自称「索尔」的古代大法师，愿意将毕生咒术传授于他。",
    worldview: ["五系魔法与元素亲和设定", "学院年度天梯赛制度", "禁书区尘封的古老秘密"],
  },
  {
    id: "elf-reincarnation",
    title: "转生为精灵王",
    category: "异世界",
    categorySlug: "isekai",
    tags: ["转生", "权谋", "种田"],
    cover: "https://readdy.ai/api/search-image?query=reincarnated%20elf%20king%20on%20a%20throne%20in%20an%20ancient%20forest%20palace%2C%20isekai%20fantasy%20manga%20cover%2C%20emerald%20gold%20and%20amber%20light%2C%20majestic%20composition&width=520&height=680&seq=elf-king&orientation=portrait",
    status: "连载中",
    rating: 4.9,
    chapters: 152,
    author: "青藤映画",
    update: "1小时前",
    description: "社畜设计师意外死亡后转生为破败精灵国度的少年国王，靠前世经验重振国运。",
    intro: "醒来时，陆言发现自己变成了一个濒临灭亡的精灵王国之主。国库空虚、四邻环伺、子民苦不堪言。他决定用前世的商业与设计头脑，为这个没落的国度换一条活路。",
    worldview: ["精灵国度的经济与政治体系", "圣树共鸣的魔法传承", "与兽人、矮人诸国的外交博弈"],
  },
  {
    id: "fox-spirit-diary",
    title: "夜行妖怪录",
    category: "妖怪志异",
    categorySlug: "yokai",
    tags: ["妖狐", "志怪", "悬疑"],
    cover: "https://readdy.ai/api/search-image?query=nine%20tailed%20fox%20spirit%20girl%20with%20paper%20lantern%20in%20an%20ancient%20village%20at%20night%2C%20oriental%20yokai%20manga%20cover%2C%20ink%20wash%20with%20crimson%20and%20gold%2C%20mysterious%20atmosphere&width=520&height=680&seq=fox-spirit&orientation=portrait",
    status: "连载中",
    rating: 4.7,
    chapters: 143,
    author: "墨守物语",
    update: "昨天",
    description: "开阴阳杂货铺的少年与一只迷路的九尾妖狐，共同追查百年前一桩未解的妖怪悬案。",
    intro: "镇上的阴阳杂货铺收留了一只不愿害人的小狐妖。她忘了自己的名字与来历，只记得百年前那个雨夜。为帮她找回记忆，少年踏上了一段跨越人妖两界的夜行之旅。",
    worldview: ["阴阳师与妖界的契约规则", "百鬼夜行的古老传闻", "狐族九尾的传承之谜"],
  },
  {
    id: "myth-reawakening",
    title: "古神话妖精战记",
    category: "神话新编",
    categorySlug: "myth",
    tags: ["神话", "史诗", "战争"],
    cover: "https://readdy.ai/api/search-image?query=epic%20mythological%20battle%20with%20gods%20fairy%20warriors%20and%20giant%20beasts%20across%20the%20sky%2C%20mythology%20manga%20cover%2C%20golden%20hour%20and%20deep%20teal%2C%20grand%20cinematic%20art&width=520&height=680&seq=myth-war&orientation=portrait",
    status: "已完结",
    rating: 4.5,
    chapters: 89,
    author: "天穹神话社",
    update: "3天前",
    description: "众神沉睡万年后苏醒，人类与妖精被迫联手，应对一场席卷天地的神话之战。",
    intro: "山崩地裂，沉睡万年的古老神明从地脉中苏醒。面对神怒与天灾，人族、妖精与神话生物不得不放下千年恩怨，共同站在天穹之下。",
    worldview: ["东方神话体系的重新演绎", "四象神兽与妖精的盟约", "神代战争的宏大战场设定"],
  },
  {
    id: "star-elf-city",
    title: "永夜精灵城",
    category: "精灵国度",
    categorySlug: "elf",
    tags: ["精灵", "战争", "虐恋"],
    cover: "https://readdy.ai/api/search-image?query=lonely%20elf%20archer%20looking%20over%20a%20glowing%20city%20that%20never%20sees%20daylight%2C%20elf%20fantasy%20manga%20cover%2C%20moonlight%20blue%20green%20and%20silver%2C%20melancholic%20painterly%20style&width=520&height=680&seq=elf-city&orientation=portrait",
    status: "连载中",
    rating: 4.4,
    chapters: 76,
    author: "月弓工作室",
    update: "昨天",
    description: "被神明诅咒、永远见不到白昼的精灵城，一个女箭手试图打破千年的黑暗封印。",
    intro: "精灵城的天空被一道无形的诅咒锁死，永夜自此降临。女箭手银羽发现，只要集齐七颗星辉，就能破除封印，让黎明重新降临。",
    worldview: ["永夜诅咒的由来与解法", "精灵弓箭与星辉魔法", "城内贵族的黑暗交易"],
  },
  {
    id: "wind-knight",
    title: "风之精灵骑士",
    category: "精灵国度",
    categorySlug: "elf",
    tags: ["骑士", "冒险", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=wind%20elf%20knight%20on%20a%20winged%20horse%20above%20the%20clouds%2C%20fantasy%20manga%20cover%2C%20bright%20sky%20blues%20greens%20and%20golden%20light%2C%20heroic%20composition&width=520&height=680&seq=wind-knight&orientation=portrait",
    status: "连载中",
    rating: 4.7,
    chapters: 118,
    author: "疾风社",
    update: "6小时前",
    description: "孤儿剑士被风精灵眷顾，成为王国最年轻骑士，踏上守护大陆的冒险之旅。",
    intro: "当风精灵的风之印记第一次在孤儿剑士肩上浮现，他便注定成为守护大陆的精灵骑士。一路结识伙伴，也揭开自己身世的真相。",
    worldview: ["风精灵眷顾的骑士传承", "王国与魔物的百年战争", "精灵骑士团的晋升之路"],
  },
  {
    id: "goddess-cat",
    title: "神明家的猫",
    category: "奇幻妖精",
    categorySlug: "fantasy",
    tags: ["日常", "温馨", "神明"],
    cover: "https://readdy.ai/api/search-image?query=cute%20fairy%20cat%20companion%20resting%20in%20a%20sunlit%20shrine%20garden%2C%20cozy%20fantasy%20manga%20cover%2C%20warm%20golden%20and%20soft%20green%2C%20gentle%20storybook%20art&width=520&height=680&seq=goddess-cat&orientation=portrait",
    status: "连载中",
    rating: 4.9,
    chapters: 164,
    author: "暖光童话",
    update: "30分钟前",
    description: "一只误闯神社的橘猫，竟意外成为了新任见习神明，展开爆笑又温馨的神明日常。",
    intro: "橘猫旺财在神社打了个盹，醒来就成了见习神明。没有法力、只会卖萌的它，在守护小镇的过程中，慢慢理解了神明的职责。",
    worldview: ["见习神明的修行日常", "小镇居民与守护神的关系", "四季祭典的温馨故事"],
  },
  {
    id: "magic-tavern",
    title: "异界茶馆物语",
    category: "异世界",
    categorySlug: "isekai",
    tags: ["经营", "治愈", "群像"],
    cover: "https://readdy.ai/api/search-image?query=cozy%20fantasy%20tavern%20with%20fairy%20customers%20and%20glowing%20teapots%2C%20isekai%20slice%20of%20life%20manga%20cover%2C%20warm%20amber%20and%20green%2C%20inviting%20atmosphere&width=520&height=680&seq=magic-tavern&orientation=portrait",
    status: "连载中",
    rating: 4.8,
    chapters: 133,
    author: "暖炉物语",
    update: "昨天",
    description: "穿越到异世界的茶馆老板，用一杯茶治愈了来自各族的神话访客。",
    intro: "开了二十年茶馆的老赵一觉醒来，竟到了妖精横行的异世界。他坚持用一碗热茶与一碟点心，招待精灵、兽人、妖怪与神明。",
    worldview: ["各族神话访客的群像故事", "异界茶馆的经营日常", "一杯茶的治愈之力"],
  },
  {
    id: "cursed-sword",
    title: "咒剑与魔女",
    category: "魔法学院",
    categorySlug: "magic",
    tags: ["魔女", "热血", "复仇"],
    cover: "https://readdy.ai/api/search-image?query=witch%20wielding%20a%20cursed%20black%20sword%20with%20purple%20black%20flames%20in%20a%20stormy%20sky%2C%20dark%20fantasy%20manga%20cover%2C%20crimson%20and%20black%2C%20intense%20atmosphere&width=520&height=680&seq=cursed-sword&orientation=portrait",
    status: "连载中",
    rating: 4.3,
    chapters: 84,
    author: "逆焰社",
    update: "2天前",
    description: "被逐出学院的天才魔女，手持染血的咒剑，向曾经背叛她的人一一复仇。",
    intro: "「把我逼入绝路的代价，你们准备好了吗？」被学院除名、被挚友背叛的天才魔女阿澈，寻得传说中的咒剑，走上了复仇与自我救赎的路。",
    worldview: ["禁咒魔法与魔女传承", "学院派系的权力倾轧", "咒剑认主的条件"],
  },
  {
    id: "sea-dragon-myth",
    title: "沧海龙神录",
    category: "神话新编",
    categorySlug: "myth",
    tags: ["龙神", "东方", "史诗"],
    cover: "https://readdy.ai/api/search-image?query=majestic%20sea%20dragon%20rising%20from%20ocean%20waves%20with%20a%20human%20girl%20on%20its%20back%2C%20oriental%20mythology%20manga%20cover%2C%20deep%20teal%20emerald%20and%20gold%2C%20epic%20art&width=520&height=680&seq=sea-dragon&orientation=portrait",
    status: "已完结",
    rating: 4.6,
    chapters: 96,
    author: "沧海社",
    update: "1周前",
    description: "渔村少女意外救起受伤的龙神，卷入四海龙宫与天神之间的古老纷争。",
    intro: "一个平静的渔村，一场突如其来的海啸，让少女阿渔救起了神话中才会出现的龙神。从此，她踏入了四海龙宫与天界之间延续千年的恩怨。",
    worldview: ["四海龙宫的势力划分", "龙神与天神的古老盟约", "渔村少女的成长线"],
  },
  {
    id: "spirit-beast-taming",
    title: "百兽妖精契",
    category: "奇幻妖精",
    categorySlug: "fantasy",
    tags: ["御兽", "冒险", "热血"],
    cover: "https://readdy.ai/api/search-image?query=young%20tamer%20with%20mythical%20spirit%20beasts%20in%20a%20vibrant%20fantasy%20world%2C%20creature%20collecting%20manga%20cover%2C%20emerald%20amber%20and%20teal%2C%20dynamic%20adventure%20art&width=520&height=680&seq=beast-taming&orientation=portrait",
    status: "连载中",
    rating: 4.5,
    chapters: 141,
    author: "御灵社",
    update: "4小时前",
    description: "人类与妖精共同生活的世界，少年踏上收集百种神兽的冒险旅途。",
    intro: "在这个世界里，人与妖精神兽立下契约，便能共享力量。立志成为最强御兽师的少年，带着他的第一只小妖精，开始了收集百兽的旅程。",
    worldview: ["妖精神兽的谱系图鉴", "御兽师的晋级体系", "人与妖精的共生规则"],
  },
];

export const faqItems = [
  {
    q: "什么是韩国妖精漫画？",
    a: "韩国妖精漫画泛指以妖精、精灵、妖怪、神话生物为主题的韩国奇幻漫画（Webtoon），通常包含奇幻、魔法、异世界、精灵、妖怪、神话等热门题材，世界观宏大、画风精美、连载更新快。",
  },
  {
    q: "网站上的漫画需要付费才能看吗？",
    a: "本站是内容聚合与导览平台，为读者提供世界观设定、最新话更新提醒与作品推荐。具体阅读渠道请前往各作品正版连载平台，支持正版创作。",
  },
  {
    q: "如何快速找到我感兴趣的那部妖精漫画？",
    a: "你可以通过顶部「分类」按奇幻、魔法、异世界、精灵、妖怪、神话等题材筛选，也可以使用站内搜索或查看「最新更新」「本周热门」榜单，快速锁定目标作品。",
  },
  {
    q: "网站的更新频率是怎样的？",
    a: "我们每日追踪热门妖精漫画的最新话更新，并在「最新更新」板块即时展示。热门连载作品的追更入口会优先展示，方便读者第一时间看到新章节。",
  },
  {
    q: "我是一名漫画创作者，可以在网站上投稿推荐吗？",
    a: "当然可以。欢迎通过「联系我们」页面提交你的作品简介、分类与连载链接，我们会审核后将符合题材定位的优秀妖精漫画收录到推荐列表中。",
  },
];